<template>
  <div>
    <b-modal :id="`bv-modal-skip-channel-${page}`" hide-footer>
      <template #modal-title>Skip channel</template>

      <div class="row">
        <div class="col">
        <div class="row">
        <div class="col">
            <label class="form-label pt-0 mb-2" for="dealer-name">{{channel.name}}</label>
            <div class="text-center">Are you sure you want to skip this channel?</div>
        </div>
      </div>

        </div>
      </div>

      <div class="row pt-3 pb-2">
        <div class="col">
                  <div>
<button v-if="updating" type="button" class="btn btn-success submit col">
  <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
        <button v-else type="button" class="btn btn-danger submit col" @click="updateChannel">Save</button>
      </div>
        </div>
      </div>

    </b-modal>
  </div>
</template> 

<script>
export default {
  props: ['channel','page'],

  data() {
    return {
      updating: false,
    };
  },

  created() {
    
  },

  methods: {

    hideModalSkipChannel() {
      this.$bvModal.hide("bv-modal-skip-channel-" + this.page);
    },

          updateChannel() {

          this.updating = true;

          axios.post('/channel/action', {
            channel: this.channel,
            action: 'skip'})
        .then((response) => {

          if (response.data.success) {
            this.hideModalSkipChannel();
          } else {
            this.sweetfire(response.data.message);
          }

          this.updating = false;

        });

      },

      sweetfire(text) {
        Swal.fire({
        title: text,
        showConfirmButton: false,
        showDenyButton: false,
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: 'Ok',
        customClass: {
                title: "popup-title",
              },
    })

    },
  },
};
</script>

<style scoped>
label.form-label {
  font-weight: 600 !important;
  text-align: center;
  display: block;
}
input.form-control {
    text-align: center;
}

.btn.btn-danger.submit, .btn.btn-secondary.submit, input.form-control {
    border-radius: 5px !important;
}
</style>